import { useState } from 'react';

type DrawerMode = 'menu' | 'locations' | null;

interface UseHeaderDrawerReturn {
	isDrawerOpen: boolean;
	drawerMode: DrawerMode;
	openMenuDrawer: () => void;
	openLocationDrawer: () => void;
	closeDrawer: () => void;
	setDrawerMode: (mode: DrawerMode) => void;
}

/**
 * Hook to manage header drawer state
 * Handles opening/closing and switching between drawer modes
 */
export const useHeaderDrawer = (): UseHeaderDrawerReturn => {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [drawerMode, setDrawerMode] = useState<DrawerMode>(null);

	const openMenuDrawer = () => {
		setIsDrawerOpen(true);
		setDrawerMode('menu');
	};

	const openLocationDrawer = () => {
		setIsDrawerOpen(true);
		setDrawerMode('locations');
	};

	const closeDrawer = () => {
		setIsDrawerOpen(false);
		setDrawerMode(null);
	};

	return {
		isDrawerOpen,
		drawerMode,
		openMenuDrawer,
		openLocationDrawer,
		closeDrawer,
		setDrawerMode,
	};
};
